import { Pipe, PipeTransform } from '@angular/core';
import * as d3 from 'd3';
import { RoutingService } from '../service/routing.service';

/**
 * This pipe defines the score color scheme 2
 */

@Pipe({ name: 'colorScore2' })
export class ColorScore2Pipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(_routing?: RoutingService) {}
  transform(value: string | number): string {
    const numericValue = parseFloat(String(value));
    if (value && !isNaN(numericValue) && numericValue !== 0) {
      const colorScale = d3
        .scaleThreshold<number, string>()
        .domain([2, 4, 6, 8])
        .range(['#FF4C23', '#FF7700', '#FFB347', '#FEF554', '#50DF6A']);
      return colorScale(numericValue) ?? 'rgb(120,120,120)';
    } else {
      return 'rgb(120,120,120)';
    }
  }
}
